import {create} from 'zustand'

export {Dialog as DialogNew} from './Dialog'
export {type DialogProps as DialogNewProps} from './Dialog'
export {DialogContent as DialogContentNew} from './Dialog.Content'
export {DialogFooter as DialogFooterNew} from './Dialog.Footer'
export {DialogHeading as DialogHeadingNew} from './Dialog.Heading'
export {DialogStyledSection} from './Dialog.StyledSection'

export type BaseDialogState<TData = any> = {
  isLoading: boolean
  isDialogOpen: boolean
  toggleIsLoading: () => void
  closeDialog: () => void
  openDialog: (data?: Partial<TData>) => void
  data?: Partial<TData>
}

export const createBaseDialogState = <TData = any> () => create<
  BaseDialogState<TData>
>()((set) => ({
  isLoading: false,
  isDialogOpen: false,
  data: undefined,
  toggleIsLoading: () => set((state) => ({isLoading: !state.isLoading})),
  closeDialog: () => set({isDialogOpen: false, data: undefined}),
  openDialog: (data) => set({isDialogOpen: true, data}),
}))